<div class="dashboard-view">
    <app-simulations class="simulations"></app-simulations>

    <!-- <section class="actions" *ngIf="links && links.length">
        <a mat-raised-button color="accent"
            *ngFor="let link of links"
            [routerLink]="link.route"
            [attr.disabled]="link.isDisabled"
            [ngClass]="{disabled: link.isDisabled}">
            <mat-icon aria-label="Nav">{{link.icon}}</mat-icon> {{link.title | translate}}
        </a>
    </section> -->
    <app-live-simulator class="simulator"
        [simulation]="simulation"
        [selectedYear]="selectedYear"></app-live-simulator>

    <app-datatables [simulation]="simulation" class="datatables"></app-datatables>
</div>

